import styled from 'styled-components';

import { px } from '../../contrib/ui';

const borderHeight = 50;
const borderWidth = 15;

export const AddIconContainerStyled = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background-color: var(--mainColor);
  position: relative;
  overflow: visible;

  height: 100%;
  width: ${px(30)};
  position: absolute;
  right: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  svg {
    color: white;
  }

  &:hover {
    filter: brightness(85%);
  }

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    left: ${px(-1 * borderWidth)};
    position: absolute;

    border-width: ${px(borderHeight)} ${px(borderWidth)} ${px(borderHeight)} 0;
    border-color: transparent var(--mainColor) transparent transparent;
    background-color: transparent;
  }
`;
